import { useShowErrorWithCallback } from './use-show-error-with-callback.hook';

export function useShowError() {
    const showError = useShowErrorWithCallback();
    return (key: any, description?: string) => showError(key, description)(() => {});
}
